module.exports = __webpack_public_path__ + "static/media/3.9ab4595a.jpg";